import { createConfig, http, type Transport } from "wagmi";
import type { Chain } from "viem";
import { VIEM_CHAINS } from "~/lib/chains";
import { rpcsTransports } from "~/lib/rpcs";

const allChains = Object.values(VIEM_CHAINS) as [Chain, ...Chain[]];

// Use Llama RPC transports where available, fall back to default for unmapped chains
const transports = Object.fromEntries(
  allChains.map((c) => [c.id, rpcsTransports[c.id] ?? http()]),
) as Record<number, Transport>;

export const wagmiConfig = createConfig({
  chains: allChains,
  transports,
  multiInjectedProviderDiscovery: false,
});
